export const loginFr = {
  "Username": "Nom d'utilisateur",
  "Password": "Mot de passe",
  "Connecter": "Connecter",
  "Wrong Data !": "Données erronées !",
  "Wrong Data !!": "Données erronées !!",
}